import { useState } from 'react';

interface IProps {
  apiData: any;
}
const TBody = ({ apiData }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      {apiData.map((data: any, index: number) => {
        const { brekdownName, type, downTime, percenatge, cummPercentage } = data;
        return (
          <tr>
            <td>{index + 1}</td>
            <td>{type}</td>
            <td>{brekdownName}</td>
            <td>{(downTime/60).toFixed(2)}</td>
            <td style={percenatge <=50 ?{background:"#51cf66"}:{}}>{percenatge}</td>
            <td>{cummPercentage}</td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default TBody;
